<template>
  <div id="previous-device">
    <img
      src="@/assets/icons/ccmc-wilderverse-lg.png"
      class="logo"
    >
    <div class="pathfinders">
      <avatar
        v-for="pathfinder in pathfinders"
        :key="pathfinder.id"
        :pathfinder="pathfinder"
        :class="{ pathfinder: true }"
        @click.native="selectPathfinder(pathfinder)"
      ></avatar>
    </div>
    <div class="actions">
      <button
        id="find-existing"
        class="button secondary"
        @click="$router.push({name: 'find'})"
      >FIND AN EXISTING PATHFINDER</button>
      <button
        class="button secondary"
        @click="newPathfinder()"
      >I NEED TO MAKE A NEW PATHFINDER</button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import Avatar from "@/components/Pathfinder/Avatar.vue";
  export default {
    name: "PreviousDevice",
    components: { Avatar },
    props: ["pathfinders"],
    methods: {
      ...mapActions(["setCurrentPathfinder"]),
      selectPathfinder(pathfinder) {
        this.setCurrentPathfinder(pathfinder);
        this.$router.push({ name: "location" });
      },
      newPathfinder() {
        this.$router.push({ name: "new" });
      }
    }
  };
</script>

<style lang="scss">
  #previous-device {
    display: flex;
    flex-direction: column;

    .logo {
      margin: auto;
      width: 85%;
    }

    .pathfinders {
      height: 65vh;
      display: flex;
      position: relative;
      flex-direction: column;
      align-items: center;
      overflow: auto;

      .pathfinder {
        width: 50%;
      }
    }

    .actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 25%;

      button {
        font-size: 3.5vw;
        height: 4em;
        width: 85%;
        white-space: normal;
        margin-bottom: 1em;
      }
    }

    @media only screen and (min-width: 600px) {
      .logo {
        width: 50%;
      }

      .actions {
        button {
          width: 75%;
          font-size: 2vw;
        }
      }
    }
  }
</style>
